import { DefaultFilter } from './constants';
export const createDependentFieldFilter = args => Object.assign({}, DefaultFilter, args);
export default createDependentFieldFilter;